import { Notification } from "@cambridgeassessment/cambridge-ui";

export const EmbargoNotification = () => {
  return (
    <Notification variant="info" className="mt-4 ml-15">
      <p className="text-start">
        <strong>
          For the selected series, either no data is available in Report Maker
          to override the embargo, or an error occurred while fetching the data.
        </strong>
      </p>
    </Notification>
  );
};
